import { render, staticRenderFns } from "./YoutubeWrapper.vue?vue&type=template&id=142d6117&"
import script from "./YoutubeWrapper.vue?vue&type=script&lang=js&"
export * from "./YoutubeWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports